 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTPROLOGUE from '@/components/Text/prologue'
 import TEXTQUOTE1 from '@/components/Text/quote1'
 import TEXTCHAPTER1 from '@/components/Text/Chapter1'
 import TEXTQUOTE2 from '@/components/Text/quote2'
 import TEXTCHAPTER2 from '@/components/Text/Chapter2'
 import TEXTQUOTE3 from '@/components/Text/Quote3'
 import TEXTCHAPTER3 from '@/components/Text/Chapter3'
 import TEXTQUOTE4 from '@/components/Text/Quote4'
 import TEXTCHAPTER4 from '@/components/Text/Chapter4'
 import TEXTQUOTE5 from '@/components/Text/Quote5'
 import TEXTCHAPTER5 from '@/components/Text/Chapter5'
 import TEXTQUOTE6 from '@/components/Text/Quote6'
 import TEXTCHAPTER6 from '@/components/Text/Chapter6'
 import TEXTQUOTE7 from '@/components/Text/Quote7'
 import TEXTCHAPTER7 from '@/components/Text/Chapter7'
 import TEXTQUOTE8 from '@/components/Text/Quote8'
 import TEXTINTERLUDE from '@/components/Text/Interlude'
 import TEXTQUOTE9 from '@/components/Text/Quote9'
 import TEXTCHAPTER8 from '@/components/Text/Chapter8'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXTPHOTOS from '@/components/Text/Photos'
 import TEXTAUTHORSNOTE from '@/components/Text/AuthorsNote'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTSAVINGSANDOVAL_EXCERPTAD_V1 from '@/components/Text/SAVINGSANDOVAL_ExcerptAd_v1'
 import TEXTAD_02 from '@/components/Text/Ad_02'
 import TEXTAD_03 from '@/components/Text/Ad_03'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/prologue",
 			"name" : "Text/prologue",
 			"component" : TEXTPROLOGUE
 		},
 		{
 			"path" : "/Text/quote1",
 			"name" : "Text/quote1",
 			"component" : TEXTQUOTE1
 		},
 		{
 			"path" : "/Text/Chapter1",
 			"name" : "Text/Chapter1",
 			"component" : TEXTCHAPTER1
 		},
 		{
 			"path" : "/Text/quote2",
 			"name" : "Text/quote2",
 			"component" : TEXTQUOTE2
 		},
 		{
 			"path" : "/Text/Chapter2",
 			"name" : "Text/Chapter2",
 			"component" : TEXTCHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js